<template>
  <div style="margin-top: -3rem;">
    <!-- Confirmation Dialog for Apply Status -->
    <md-dialog :md-active.sync="showApplyStatusConfirm" class="dialog-settings">
      <md-dialog-title style="text-align: center;">{{ options.Lang.confirmation || 'Confirmation' }}</md-dialog-title>
      <md-dialog-content style="text-align: center;">
        {{ options.Lang.apply_to_all_pdf || 'Are you sure you want to apply this status to all PDFs?' }}
        <br><br>
        <strong>PDF:</strong> {{ pendingApplyPdf?.pdfname }}<br>
        <strong>Status:</strong> {{ pendingApplyPdf?.defaultValue === '1' ? 'Enabled' : 'Disabled' }}
      </md-dialog-content>
      <md-dialog-actions class="dialog-custom-actions-settings">
        <md-button class="md-primary md-raised" style="background-color: green;" @click="confirmApplyStatus">{{ options.Lang.yes || 'Yes' }}</md-button>
        <md-button @click="cancelApplyStatus">{{ options.Lang.Abbrechen || 'Cancel' }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Confirmation Dialog for Remove PDF -->
    <md-dialog :md-active.sync="showRemoveConfirm" class="dialog-settings">
      <md-dialog-title style="text-align: center;">{{ options.Lang.confirmation || 'Confirmation' }}</md-dialog-title>
      <md-dialog-content style="text-align: center;">
        {{ options.Lang.confim_pdf_delete || 'Are you sure you want to delete this PDF?' }}
        <br><br>
        <strong>{{ options.Lang.Datei || 'File' }}:</strong> {{ pendingRemovePdf?.pdfname }}
        <br>
        {{ options.Lang.no_undone || 'This action cannot be undone.' }}
      </md-dialog-content>
      <md-dialog-actions class="dialog-custom-actions-settings">
        <md-button class="md-primary md-raised" style="background-color: #d32f2f; color: white;" @click="confirmRemovePDF">{{ options.Lang.Löschen || 'Delete' }}</md-button>
        <md-button @click="cancelRemovePDF">{{ options.Lang.Abbrechen || 'Cancel' }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-content v-if="renderComponent">
      <div class="ml-30 pt-30">
        <md-dialog-title style="margin-left: -2%; font-size: 2rem;">{{ options.Lang.Pdf_Kategorien_bearbeiten }}</md-dialog-title>
      </div>

      <div class="p-30" style="background-color: white; margin-top: 2rem;">
        <br>
        <table class="tableclass2-timeline" style="width: 100%;">
          <tr>
            <td style="width: 30%;padding-left: 13px;" class="categorie">
              {{options.Lang.Kategorie}}
            </td>
            <td style="width: 30%;" class="categorie">
              {{options.Lang.Verknüpfte_Dateien}}
            </td>
            <td style="width:20%;padding-left: 20px;" class="categorie">
            </td>
          </tr>

        </table>
        <table class="settingsTable" v-for="(cat, index) in categories" :key="index">
          <tr class="settingsTr">
            <td class="settingsTdPdf">
              {{ cat.name }}
            </td>
            <td class="verknüpfte">
              {{ cat.count }}
            </td>
            <td style="width: 20%; text-align: right;">
              <md-button style="margin:0; min-width:50px" @click="editCategorie(cat.id, cat.name)">
                <md-icon>edit</md-icon>
              </md-button>
              <md-button style="margin:0; min-width:50px"  @click="rmvCategorie(cat.id)">
                <md-icon>delete</md-icon>
              </md-button>
            </td>
          </tr>
        </table>
        <br>
        <br>
        <h5>{{options.Lang.Kategorie_hinzufügen}}</h5>

        <form novalidate class="md-layout">
          <div class="md-layout-item">
            <md-field class="md-focused">
              <label for="filename"><strong>{{options.Lang.Kategorie}}</strong></label>
              <md-input tabindex="4" name="fileName" @change="getCatName" id="fileName" required
                :placeholder=options.Lang.Kategorie />
              <div style="float: right;">
                <md-button tabindex="7" class="md-raised md-primary" @click="uploadCat()"><strong>{{options.Lang.Speichern}}</strong>
                </md-button>
                <!-- <md-button tabindex="8" class="md-raised secondary" @click="closeDialog"><strong>{{options.Lang.Zurück}}</strong></md-button> -->
                
              </div>
            </md-field>
          </div>
          <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>
        </form>
      </div>
      <!--allgemeine unterlagen-->
      <br><br>
      <div class="ml-30 pt-30">
        <md-dialog-title style="margin-left: -2%; font-size: 2rem;">{{ options.Lang.pdfAllgemein }}</md-dialog-title>
      </div>
      <div class="p-30" style="background-color: white; margin-top: 2rem;">
        <h5>{{options.Lang.Pdf_hochladen}}</h5>

        <table class="tableclass2-timeline" style="width: 100%;">
            <tr>
              <td style="width: 50%; padding: 0; padding-left: 1rem;" class="name1">
                {{options.Lang.Name}}
              </td>
              <td style="width: 30%; padding: 0; padding-left: 1rem;" class="name1">
                {{options.Lang.Branding}}
              </td>
              <td style="width: 30%; padding: 0; padding-left: 1rem;" class="name1">
                _Default
              </td>
              <td style="width: 30%;padding-left: 20px;" class="action">
                
              </td>
            </tr>
        </table>

        <table class="formTD"  v-for="(pdf, index) in pdfs" :key="index" style="width: 100%;">
            <tr>
              <td style="width: 50%; padding-left: 20px;">
                {{ pdf.pdfname }}
              </td>
              <td style="width: 30%; padding-left: 20px;">
                {{ pdf?.showBrand ? pdf.showBrand : ''}}
              </td>
              <td style="width: 10%; padding-left: 10px;">
                <div class="md-layout-item inline" style="display: flex; align-items: center; justify-content: space-between;">
                  <div @click="showApplyStatusDialog(pdf)">
                    <md-icon style="cursor: pointer;">reply_all</md-icon>
                  </div>
                  <md-field class="md-focused" style="padding-bottom: 10px">
                    <md-select v-model="pdf.defaultValue" @md-selected="defautltPdf(pdf)" name="default_pdf" id="default_pdf">
                      <md-option value="0">Disabled</md-option>
                      <md-option value="1">Enabled</md-option>
                    </md-select>
                  </md-field>

                </div>
              </td>
              <td style="width: 30%;">
                <a v-bind:href="'./' + pdf.pdf" target="_blank">
                  <div style="float: right; height: 40px; padding-top: 7px;">
                    <md-icon style="color:black;">travel_explore</md-icon>
                  </div>
                </a>
                <div style="float: right; height: 40px; padding-top: 7px;" v-bind:id="pdf.id" @click="checkInput(pdf.id)">
                  <md-icon style="color:#1A7777; cursor: pointer;">autorenew</md-icon>
                </div>
                <div style="float: right; height: 40px; padding-top: 7px;" v-bind:id="pdf.id" @click="showRemoveDialog(pdf)">
                  <md-icon style="color:#EA7C7C; cursor: pointer;">delete</md-icon>
                </div>
              </td>
            </tr>
        </table>
        <div v-if="pdfs.length <= 0" style="margin-left: 1rem;">
          <br>
          <label>{{ options.Lang.keine_Daten_gefunden }}</label>
        </div>
        <br><br>
        <form class="md-layout">
          <div class="md-layout-item">
            <md-field class="md-focused">
              <label for="filename"><strong>{{ options.Lang.Name }}</strong><span class="asterix"></span></label>
              <md-input tabindex="4" name="fileName" @change="getFileName" id="fileName" style="width: 340px;"
                        v-model="fileName" required
              />
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field class="md-focused">
              <label for="selectBrand"><strong>{{ options.Lang.Branding }}</strong><span class="asterix">*</span></label>
              <md-select v-model="selectBrand" @md-selected="getBrandForPdf()" name="selectBrand" id="selectBrand">
                <md-option v-for="(brand, index) in brands" :key="'brandIndex'+index" :value="brand.id">{{ brand.adresse }}</md-option> 
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item" >
            <md-field class="md-focused" style="display: flex; justify-content: space-between;">
              <label for="pdf"><strong>{{ options.Lang.Pdf_wählen }}</strong><span class="asterix">*</span></label>
              <input class="test" type="file" tabindex="4" @change="getUploadFile" name="uploadFile" id="uploadFile"
              accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.oasis.opendocument.text"
              ref="uploadInput"/>
              <md-button style="float: right;" tabindex="7"  class="md-raised md-primary" @click="checkInput(0)"><strong>{{ options.Lang.Hochladen }}</strong></md-button>
            </md-field>
          </div>
        </form>
      </div>


      <Success :options="options"></Success>
    </md-dialog-content>
    <!--////-->
    <div class="editCat" v-if="editCat">
      <div class="bgEdit"></div>
      <div class="contentEdit">
        <div class="md-layout-item">
            <md-field class="md-focused dFlex">
              <label for="filename"><strong>{{options.Lang.Kategorie_bearbeiten}}</strong></label>
              <md-input tabindex="4" :placeholder="editnewName" :value="editnewName" name="fileName" @change="getNewCatName" id="fileName" required />
              <div class="buttonContainer">
                <md-button tabindex="7" class="md-raised md-primary" id="sendButton" @click="uploadNewCat()">{{ options.Lang.Speichern }}</md-button>
                <md-button tabindex="8" class="md-raised secondary" @click="closeEdit()"><strong>{{options.Lang.Fenster_schließen}}</strong></md-button>
              </div>
            </md-field>
          </div>
      </div>
    </div>
    <div>
  </div>
</div>
</template>
  
<script>
import {validationMixin} from 'vuelidate'
import Success from '../../components/dialogs/Success.vue'
import Error from '../../components/dialogs/Error.vue'
import ViewUtils from "../../services/ViewUtils";


export default {
  name: 'formPdfCategorie',
  mixins: [validationMixin],
  components: {
    Success,
    Error,
  },
  props: {
    options: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    fileName: null,
    selectBrand: null,
    pdfs: [],
    Dpdf: null,
    defaultBrandPdf: null,
    uploadFile: null,
    renderComponent: false,
    brands:[],
    editnewName: null,
    finalNew: null,
    editnewId: null,
    editCat: false,
    newCat: null,
    categories: [],
    check: false,
    // New properties for confirmation dialogs
    showApplyStatusConfirm: false,
    showRemoveConfirm: false,
    pendingApplyPdf: null,
    pendingRemovePdf: null,
  }),
  created() {
  },
  mounted() {
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
    let self = this;
    self.getPdfs();
    self.getModules();
    self.getCount();
  },
  watch: {

  },
  updated(){
    
  },
  methods: {
    async getPdfs(){
      let self = this;
      this.doPost({}, 'getAllCategoriesToPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          self.categories = result;
        }
      });
      this.doPost({}, 'getAllgemeinPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          self.pdfs = result;
        }
      });
    },
    async getBrandName(){
      let self = this;
      self.renderComponent = false;
      self.pdfs.forEach(pdf =>{
          self.brands.forEach(brand =>{
            if(pdf.branding_id === brand.id){
              pdf.showBrand = brand.adresse
            }
          })
        })
        self.renderComponent = true;
      //location.reload();
        
    },
    getBrandForPdf(){
      //alert(this.selectBrand)
    },
    getModules(){
      this.renderComp = false;
      let self = this;
      self.brands = []
    self.doPost({}, 'getAllBranding', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        //console.log(result)        
        for(let i = 0; i < result.length; i++){
          self.brands.push(result[i])
        
        }
        //console.log(self.brands, "modules")

        self.getBrandName();




        self.renderComp = true;

      }
    });
    },
    applyStatusToAllPdfs(pdf){
      const self = this;
      const pdfData = {
        name: pdf.pdf,
        status: pdf.defaultValue
      }
      self.doPost({data:pdfData} , 'applyStatusToGeneralPdfs', function (res) {
        if (res.data.status === 'error') {
          if (self.help && self.help.log) {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            console.error(self.$t(res.msg));
          }
        } else {
          console.log('PDF status updated successfully');
        }
      });
    },
    defautltPdf(pdf){
      const self = this;
      const pdfData = {
        table: 'pdfallgemein',
        field: 'defaultValue',
        id: pdf.id,
        value: pdf.defaultValue
      }
      self.doPost({data:pdfData} , 'changeField', function (res) {
        if (res.data.status === 'error') {
          if (self.help && self.help.log) {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            console.error(self.$t(res.msg));
          }
        } else {
          console.log('PDF default updated successfully');
        }
      });
    },
    removePDF(pdfId) {
      this.pdfs.forEach(element =>{
        if(element.id === pdfId){
          this.Dpdf = element;
        }
      })
      //console.log(this.Dpdf, "DELEEEEEETE")
      this.options.isUploading = true;
      let self = this;
      //remove from allgemein table
      self.doPost({data: this.Dpdf}, 'removeAllgemeinPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //do stuff
          self.options.isUploading = false;
          self.doPost({}, 'getAllgemeinPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        self.pdfs = res.data.data;
        //console.log(self.pdfs);
      }
      //location.reload();
    });

        }
      })
     
      
      self.doPost({data: this.Dpdf}, 'removeAllgemeinPdfTrip', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.getBrandName();
        }
      });
      
    },
    async reUploadPDf(pdfId){
      this.options.isUploading = true;
      if (!this.uploadFile && !this.fileName && !this.selectBrand) {
        this.options.isUploading = false;
        this.options.showError = true;
      }else{
        await ViewUtils.sendPdfToAPI(this, pdfId);
        await this.getPdfs();
        this.$refs.uploadInput.value = "";
        this.options.isUploading = false;
      }
    },
    async uploadPDF() {
     if (this.uploadFile === "" || this.fileName === "" || this.selectBrand === "") {
       this.options.isUploading = false;
     }else{
        await ViewUtils.sendPdfToAPI(this);
        window.setTimeout(this.getBrandName(), 1000)
        this.$refs.uploadInput.value = "";
     }
   },
    checkInput(pdfId = 0){
      if(pdfId !== 0){
        this.reUploadPDf(pdfId);
        return;
      }
      if (this.uploadFile == null || this.fileName == null || this.selectBrand == null) {
        this.options.isUploading = false;
        this.options.showError = true;
        //this.refreshDialog();
      }else{
        this.uploadPDF();
      }
    },
    getFileName(event) {
      this.fileName = event.target.value;
    },
    getUploadFile(event) {
      this.uploadFile = event.target.files[0];
    },
    async getCount(){
      this.renderComponent = false;
      let self = this;
      await this.doPost({}, 'getAllPdfs', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result2 = res.data.data;
        self.categories.forEach(cat => {
          cat.count = 0;
        })
        self.categories.forEach(cat => {
          result2.forEach(dbEntrie =>{
          if(cat.name == dbEntrie.name){
            cat.count++
          }
        })
        })
        self.renderComponent = true;    
      }
    });
    await self.$nextTick(function(){
      self.renderComponent = true;
      //console.log(self.categories)
    });
    },
    editCategorie(id, name){
      this.editCat = true
      this.editnewId = id
      this.editnewName = name
    },
    async closeEdit(){
      this.editCat = false
      let self = this;
    this.doPost({}, 'getAllCategoriesToPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
        //console.log(self.categories);
      }
    });
    self.getCount();
    },
    getNewCatName(event) {
      this.finalNew = event.target.value;

      if(this.finalNew == null || this.finalNew == ""){
        let button = document.getElementById("sendButton")
        button.setAttribute("disabled", true)
        
      }else{
        let button = document.getElementById("sendButton")
        button.removeAttribute("disabled")
      }
    },
    rmvCategorie(id) {
      let self = this;
      //do Post => remove alle pdfs mit kategorie
      self.doPost({ data: id }, 'removeAllPdfToCat', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //do stuff
          self.refreshDialog();
        }
      });
      //do post => remove kategorie
      self.doPost({ data: id }, 'removeCatToPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //do stuff
          self.refreshDialog();
        }
      });
    self.doPost({}, 'getAllCategoriesToPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
        //console.log(self.categories);
      }
    });
    self.getCount();
    },
    refreshDialog() {
      let self = this;
      self.options.showPdfCategorieForm = false;
      self.$nextTick(() => {
        // Adding the component back in
        self.options.showPdfCategorieForm = true;
      });
    },
    uploadNewCat(){
      this.categories.forEach(element => {
        if (element.name == this.finalNew) {
          this.check = true
          //alert("upsi")
          this.refreshDialog();
        }
      });
      if (this.check == false) {
        //alert("nicht upsi")
        this.uploadCatFullNew();
      }
    },
    uploadCatFullNew(){
      if (this.finalNew != null) {
        let self = this;
        let mydata = {
          id: this.editnewId,
          name: this.finalNew
        }
        self.doPost({ data: mydata }, 'editCategorie', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.check = 0;
            self.refreshDialog();
          }
        });
        mydata.oldName = this.editnewName;
        self.doPost({ data: mydata }, 'editCategorieNameForAllPDFS', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.check = 0;
            self.options.showSuccess = true;
            self.refreshDialog();
          }
        });
    self.doPost({}, 'getAllCategoriesToPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
        //console.log(self.categories);
      }
    });
    self.getCount();
      } else {
        this.options.showError = true;
      }
    },
    uploadCat() {
      //cat schon vorhanden?
      this.categories.forEach(element => {
        if (element.name == this.newCat) {
          this.check = true
          this.refreshDialog();
        }
      });
      if (this.check == false) {
        this.uploadCatFull();
      }
    },
    uploadCatFull() {
      if (this.newCat != null) {
        let self = this;
        self.doPost({ data: self.newCat }, 'uploadCatToPdf', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            self.check = 0;
            //self.refreshDialog();
          }
        });
        self.doPost({}, 'getAllCategoriesToPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.categories = result;
        //console.log(self.categories);
      }
    });
    self.getCount();
      } else {
        this.options.showError = true;
      }


    },
    getCatName(event) {
      this.newCat = event.target.value;
    },
    closeDialog() {
      this.options.showPdfCategorieForm = false;
    },
    showApplyStatusDialog(pdf) {
      this.pendingApplyPdf = pdf;
      this.showApplyStatusConfirm = true;
    },
    confirmApplyStatus() {
      this.applyStatusToAllPdfs(this.pendingApplyPdf);
      this.showApplyStatusConfirm = false;
    },
    cancelApplyStatus() {
      this.showApplyStatusConfirm = false;
    },
    showRemoveDialog(pdf) {
      this.pendingRemovePdf = pdf;
      this.showRemoveConfirm = true;
    },
    confirmRemovePDF() {
      this.removePDF(this.pendingRemovePdf.id);
      this.showRemoveConfirm = false;
    },
    cancelRemovePDF() {
      this.showRemoveConfirm = false;
    },
  }
}
</script>
<style>
.bgEdit{
  background-color: black;
  height: 100%;
  width: 100%;
  opacity: 0.5;
}
.editCat{
  z-index: 111111;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
}
.contentEdit{
  padding: 4rem;
  background-color: white;
  position: absolute;
  height: auto;
  top: 18rem;
  width: 70%;
  left: 15%;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
  vertical-align: bottom;
  border-collapse: collapse;

}

.settingsTable {
  width: 100%;
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
  vertical-align: bottom;
  border-collapse: collapse;
}

.settingsTr {
  height: 50px;
  background-color: white;
  border-bottom: 0.4000000059604645px solid #97979767;
}

.settingsTdPdf {
  width: 30%;
  padding-left: 13px;
}

.verknüpfte {
  width: 30%;
  padding-left: 2px;
}

#fileName{
  -webkit-text-fill-color: black !important;
}
.dFlex {
  display: flex;
  flex-direction: column !important;
}
.buttonContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 3rem;
  margin-bottom: -1rem;
}
.dialog-settings{
  max-width: 400px !important;
  margin: 0 auto;
}
.dialog-custom-actions-settings{
  justify-content: center !important;
}

</style>